import { render, staticRenderFns } from "./mark-favourite-widget.vue?vue&type=template&id=017234c2&"
import script from "./mark-favourite-widget.vue?vue&type=script&lang=js&"
export * from "./mark-favourite-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports